<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <slot></slot>
    </div>
    <slot name="other"></slot>
  </div>
</template>

<script>
import Swiper from 'swiper';
export default {
  data() {
    return {
      defaultOpts: {
        autoplay: {
          delay: 2500,
        },
        loop: true,
      }
    }
  },
  props: {
    opts: {}
  },
  mounted() {
    const opts = Object.assign({}, this.defaultOpts, this.opts);
    new Swiper('.swiper-container', opts);
  }
}
</script>

<style lang="less" scoped>
@middleWidth: 1200px;

.swiper-container {
  height: 100%;
  min-width: @middleWidth;

  .swiper-slide > img {
    width: 100%;
    height: 100%;
  }
}
</style>